// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import GroupAvailability from './group-availability';
import React from 'react';

function GroupAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-group-availability-page">
            <GroupAvailability />
        </AuthenticatedPage>
    );

}
GroupAvailabilityPage.displayNAme = 'GroupAvailabilityPage';

export default GroupAvailabilityPage;
